<div class="paybee-modal-header">
    <div class="row">
        <div class="col-10">
            <div class="modal-main-heading">{{ header }}</div>                            
        </div>
    </div>
    <div class="row">
        <div class="col">
            <div class="modal-sub-heading">{{ subheader }}</div>
        </div>
    </div>
    <div class="row mt-3">
        <div class="col">
            <div class="modal-sub-heading"><b>Printing instructions: </b>{{ instructions }}</div>
        </div>
    </div>
</div>
<div class="modal-body mx-3 text-center">
    <object #qrCardPreviewObject type="application/pdf" style="height: 640px; width: 410px;"></object>
</div>
<div class="modal-footer">
  <div class="d-flex w-100 justify-content-end">
    <button type="button" class="btn btn--paybee modal-outline-button btn--md text-center mr-2" (click)="close()">Close</button>
    <a [href]= data.fileName  target="_blank" class="btn btn--paybee btn--purple button waves-effect waves-light" download>Download Fundraiser QR Codes</a>
  </div>
</div>
